import ResizableScene from "../core/ResizableScene";
import ScrollRect from "./ScrollRect";

export default class Scrollbar extends Phaser.GameObjects.Container {

    scene: ResizableScene;
    bg: Phaser.GameObjects.Image;
    scrollbar: Phaser.GameObjects.Image;
    scrollRect: ScrollRect;

    pointerDown = false;

    constructor(scene: ResizableScene, height = 300) {
        super(scene);

        const scrollRect = this.bg = scene.add.image(0, 0, "scrollBarBG");
        scrollRect.setScale(1, height / scrollRect.height);
        scrollRect.alpha = 0;
        const scrollbar = this.scrollbar = scene.add.image(0, 0, "sideSlider");
        scrollbar.setOrigin(0.5, 0);
        this.add([scrollRect, scrollbar]);

        this.setSize(Math.max(scrollbar.width, scrollRect.width), height);
        scene.alignIn.Center(scrollbar, scrollRect);

        scrollbar.setInteractive();
        scrollbar.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
        scene.input.on(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
        scene.input.on(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
    }

    setScrollRect(scrollRect: ScrollRect): void {
        this.scrollRect = scrollRect;
    }

    setProgress(amt: number): void {
        const min = 0;
        const max = this.height - this.scrollbar.height;
        this.scrollbar.y = min + (max - min) * amt - this.height / 2;
    }

    getProgress(): number {
        const min = 0;
        const max = this.height - this.scrollbar.height;
        return (this.scrollbar.y - min) / (max - min);
    }

    onPointerDown(): void {
        this.pointerDown = true;
    }

    onPointerMove(ptr: Phaser.Input.Pointer): void {
        const pos = new Phaser.Math.Vector2(ptr.worldX, ptr.worldY);
        const transform = this.getWorldTransformMatrix();
        const localPos = transform.applyInverse(pos.x, pos.y);
        if (this.pointerDown) {
            this.scrollbar.y = localPos.y + this.height / 2 - this.scrollbar.height / 2;
            this.scrollbar.y = Phaser.Math.Clamp(this.scrollbar.y, 0, this.height - this.scrollbar.height);
            this.scrollRect.setScrollbarProgress(this.getProgress());
        }
    }

    onPointerUp(): void {
        if (this.pointerDown) this.pointerDown = false;
    }
}